/* eslint-disable camelcase */
export const VERSION = "4.10.13"

export const ANCHOR_TOP = "anchor_top"

export const DATE_FORMAT = "yyyy-MM-dd"
export const DATE_TIME_FORMAT = "yyyy-MM-dd HH:mm"

export const DARK = "dark"
export const LIGHT = "light"

export const ASC = "asc"
export const DESC = "desc"

export const CREATED_AT = "createdAt"

export const TABLE_EDITABLE_CELL = "editable-cell"

export const YES = "yes"
export const NO = "no"

export const NONE = "none"
export const VALUE = "value"
export const UNLIMITED = "unlimited"

export const LIST = "list"
export const VIEW = "view"
export const ADD = "add"
export const EDIT = "edit"
export const DELETE = "delete"
export const BLOCKS = "blocks"

export const NO_SELECTION = "no"
export const PRESENT = "present"
export const PARTIAL = "partial"

export const NEW = "new"
export const IDLE = "idle"
export const PENDING = "pending"
export const PENDING_REVIEW = "pending_review"
export const IN_PROGRESS = "in_progress"
export const SUCCEEDED = "succeeded"
export const SUPPOSEDLY_COMPLETED = "supposedly_completed"
export const COMPLETED = "completed"
export const DEFERRED = "deferred"
export const FAILED = "failed"
export const APPROVED = "approved"
export const OPEN = "open"
export const VERIFICATION = "verification"
export const ARCHIVED = "archived"

export const NOW = "now"
export const NEXT_2_DAYS = "next_2_days"
export const YESTERDAY = "yesterday"
export const CURRENT_DAY = "current_day"
export const TOMORROW = "tomorrow"
export const THIS_WEEK = "this_week"
export const THIS_MONTH = "this_month"
export const LAST_7_DAYS = "last_7_days"
export const LAST_30_DAYS = "last_30_days"
export const LAST_60_DAYS = "last_60_days"
export const LAST_90_DAYS = "last_90_days"
export const EXACT_DATE = "exact_date"
export const CUSTOM_RANGE = "custom_range"

export const ACTIVE = "active"
export const INACTIVE = "inactive"
export const PUBLISHED = "published"
export const UNPUBLISHED = "unpublished"

export const PRIMARY = "primary"
export const SUCCESS = "success"
export const WARNING = "warning"
export const DANGER = "danger"
export const INFO = "info"

export const PUBLIC = "public"
export const NON_PUBLIC = "non_public"
export const PRIVATE = "private"

export const TEXT = "text"
export const YES_NO = "yes_no"
export const MULTIPLE = "multiple"

export const SET = "set"
export const PARAGRAPH = "paragraph"
export const ITEM = "item"
export const OUTSIDE = "outside"
export const INSIDE = "inside"
export const BEFORE = "before"
export const AFTER = "after"

export const COMPLIANCE = "compliance"
export const REVIEW = "review"
export const REQUIREMENTS = "requirements"

export const INFINITE = "infinite"

export const WATERFALL = "waterfall"
export const V_MODEL = "v_model"
export const SPIRAL_MODEL = "spiral_model"
export const AGILE_MODEL = "agile_model"

export const TYPE_A = "A"
export const TYPE_B = "B"

export const LOW_DEMAND_MODE = 1
export const HIGH_DEMAND_MODE = 2
export const CONTINUOUS_MODE = 3

export const AVERAGE = "average"
export const BAYSIAN = "baysian"

export const NUMBER = "number"
export const FIT = "fit"
export const SCIENTIFIC = "scientific"
export const MTTF_HOURS = "mttf_hours"
export const MTTF_YEARS = "mttf_years"
export const MTTF_1_YEAR_HOURS = 8760 // number of hours in 1 year = 365 days * 24 hours
export const FIT_RATIO = 1000000000

export const DECIMAL = "decimal"
export const PERCENT = "percent"

export const PROVEN_NO = 0
export const PROVEN_IN_USE = 1
export const PRIOR_USE = 2

export const PFD = "pfd"
export const PFH = "pfh"

// architectural constraints and calculation methods
export const NO_DANGEROUS_FAILURE = "no_dangerous_failure"
export const NO_SAFE_FAILURE = "no_safe_failure"
export const NO_ARCHITECTURAL_CONSTRAINTS = "no_architectural_constraints"
export const IEC_61508_2010 = "iec_61508_2010"
export const IEC_61508_1998 = "iec_61508_1998"
export const IEC_61511_2016 = "iec_61511_2016"
export const IEC_61511_2003 = "iec_61511_2003"
export const ISA_TR84_2002 = "isa_tr84_2002"
export const ISA_TR84_2022 = "isa_tr84_2022"
export const VDI_VDE_2180_2019 = "vdi_vde_2180_2019"

// architectures
export const ARCHITECTURE_1oo1 = "1oo1"
export const ARCHITECTURE_1oo2 = "1oo2"
export const ARCHITECTURE_1oo2D = "1oo2D"
export const ARCHITECTURE_1oo3 = "1oo3"
export const ARCHITECTURE_2oo2 = "2oo2"
export const ARCHITECTURE_2oo3 = "2oo3"
export const ARCHITECTURE_2oo4 = "2oo4"
export const ARCHITECTURE_3oo3 = "3oo3"

export const AWS_BUCKET = "risk-tools-dev"
export const STORAGE_AWS = "aws"
export const STORAGE_GOOGLE = "google"
export const STORAGE_MICROSOFT = "microsoft"

// error drive messages
export const CONNECTION_FAILED = "CONNECTION_FAILED"
export const WRONG_CONFIG_FORMATTING = "WRONG_CONFIG_FORMATTING"
export const NO_DRIVE_CONNECTED = "NO_DRIVE_CONNECTED"
export const ERROR_UPLOAD = "ERROR_UPLOAD"

export const RECYCLE_INDEX = "_fid"

export const USER_REPLACE = "{USER}"
export const EMAIL_REPLACE = "{EMAIL}"
export const COMPANY_REPLACE = "{COMPANY}"
export const CONFIRM_LINK_REPLACE = "{CONFIRM_LINK}"

export const LANG_EN = "en"
export const LANG_FR = "fr"
export const LANG_ES = "es"
export const LANG_IT = "it"
export const LANG_DE = "de"
export const LANG_PT = "pt"
export const LANG_RU = "ru"
export const DEFAULT_LANG = LANG_EN
export const LANGUAGES = [
    LANG_EN,
    LANG_FR,
    LANG_ES,
    LANG_IT,
    LANG_DE,
    LANG_PT,
    LANG_RU,
]

export const WORKFLOW_LEVEL_ASSIGNED = "level_assigned"
export const WORKFLOW_RETURN_TO_LEVEL = "return_to_level"
export const WORKFLOW_SEND_TO_LEVEL = "send_to_level"
export const WORKFLOW_APPROVED = "approved"
export const WORKFLOW_RERUN = "rerun"

export const LOCAL_STORAGE_USER_ID = "LOCAL_STORAGE_USER_ID"
export const LOCAL_STORAGE_SESSION_ID = "LOCAL_STORAGE_SESSION_ID"
export const LOCAL_STORAGE_LANG_ID = "LOCAL_STORAGE_LANG_ID"
export const LOCAL_STORAGE_LANG_REPORT_ID = "LOCAL_STORAGE_LANG_REPORT_ID"
export const LOCAL_STORAGE_THEME = "LOCAL_STORAGE_THEME"
export const LOCAL_STORAGE_SHOW_PACKAGE_EXPIRED = "LOCAL_STORAGE_SHOW_PACKAGE_EXPIRED"


export const SOCKET_SET_CLIENT_USER_DATA = "SOCKET_SET_CLIENT_USER_DATA"
export const SOCKET_CLEAR_CLIENT_USER_DATA = "SOCKET_CLEAR_CLIENT_USER_DATA"
export const SOCKET_SEND_ONLINE_USERS = "SOCKET_SEND_ONLINE_USERS"
export const SOCKET_SET_SERVER_USER_DATA = "SOCKET_SET_SERVER_USER_DATA"
export const SOCKET_UPDATE_SERVER_USER_DATA = "SOCKET_UPDATE_SERVER_USER_DATA"
export const SOCKET_GET_SERVER_USER_DATA = "SOCKET_GET_SERVER_USER_DATA"
export const SOCKET_CLEAR_SERVER_USER_DATA = "SOCKET_CLEAR_SERVER_USER_DATA"

export const SOCKET_CLEAR_SERVER_DRIVE_CONNECTION = "SOCKET_CLEAR_SERVER_DRIVE_CONNECTION"

export const PAYMENT_UPGRADE = "upgrade"
export const PAYMENT_DOWNGRADE = "downgrade"
export const PAYMENT_BUY = "buy"
export const PAYMENT_CURRENCY = "usd"

export const PAYMENT_FREE = "free"
export const PAYMENT_STRIPE = "stripe"
export const PAYMENT_WT = "wt"
export const PAYMENT_OTHER = "other"

export const FIRST_DAY_OF_MONTH = "first_day_of_month"
export const LAST_DAY_OF_MONTH = "last_day_of_month"
export const SPECIFIC_DATE = "specific_date"
export const TODAY = "today"

export const ONE_QUARTER = "one_quarter"
export const HALF_YEAR = "half_year"
export const ONE_YEAR = "one_year"

export const WEEKLY = "weekly"
export const BIWEEKLY = "biweekly"
export const MONTHLY = "monthly"

export const MONDAY = "monday"
export const TUESDAY = "tuesday"
export const WEDNESDAY = "wednesday"
export const THURSDAY = "thursday"
export const FRIDAY = "friday"

export const INCREASE_TO = "increase_to"
export const DECREASE_TO = "decrease_to"
export const STAY_ABOVE = "stay_above"
export const STAY_BELOW = "stay_below"
export const ACHIEVED = "achieved"

export const HARD = "hard"
export const HARD_SOFT = "hard_soft"

export const CONFIDENCE_LOW = "low"
export const CONFIDENCE_MEDIUM = "medium"
export const CONFIDENCE_HIGH = "high"

// since DB keeps floats with 3 decimals, this value used for correct javascript calculations
export const EPSILON = 1000
